<script>
  import options from './DocumentAndFolderList.options'
  export default options
</script>

<template>
  <article class="kb-document-and-folder-list">
      <div class="kb-document-and-folder-list__header">
      
        <div class="kb-document-and-folder-list__header-top">
          <div class="kb-document-and-folder-list__header-top-navigation" v-if="hasParentMappe">
            <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><path d="M3.875 9 1.158 6l2.717-3" stroke="#3C3C3C" stroke-linejoin="round"/><path d="M4.19 6H13" stroke="#3C3C3C"/></svg>
            <a :href="parentMappeUrl">{{ parentMappeName }}</a>
          </div>
          <div class="kb-document-and-folder-list__header-top-title">
            <div class="kb-document-and-folder-list__header-top-title-text">
              {{ mappeName }}
            </div>
            <div class="kb-document-and-folder-list__header-top-title-sortingtoggle" v-if="!isDesktop" v-on:click="toggleShowSorting">
              {{ getLabel('toggleSorting')  }}
            </div>
          </div>
        </div>

        <div class="kb-document-and-folder-list__header-sorting" v-if="showSorting || isDesktop">
          <FormInputDropdown
            v-model="sorting"
            :localValue="sorting"
            fieldName="sorting"
            :modelValue="sorting"
            :label="Sortering"
            :selectOptions="sortingOptions"
            :onChangeCallback="(e) => sorting = e.target.value"
          />
        </div>
      </div>

      <ul class="kb-document-and-folder-list__wrapper">

        <template v-for="file, index in files" :key="index">
          <li class="kb-document-and-folder-list__wrapper-element">
            <FileListCard 
              :cardData="file"
              :cardButtonIcons="cardButtonIcons"
            />
          </li>
        </template>

      </ul>

      <div class="kb-document-and-folder-list__actions">
        <button v-on:click="(e)=> startOverlayFunction(e, 'CreateFolderOverlay')" class="kb-button kb-button--outline" aria-haspopup="dialog">{{ getLabel('newFolderButtonLabel') }}</button>
        <div v-if="hasParentMappe" class="kb-document-and-folder-list__actions-wrapper-right">
          <button v-on:click="(e)=> startOverlayFunction(e, 'CreateNewFileOverlay')" class="kb-button kb-button--outline" aria-haspopup="dialog">{{ getLabel('newFileButtonLabel') }}</button>
          <button v-on:click="(e)=> startOverlayFunction(e, 'UploadNewFileOverlay')" class="kb-button kb-button--outline" aria-haspopup="dialog">{{ getLabel('uploadNewFileButtonLabel') }}</button>
        </div>
      </div>
    </article>

    <div v-if="isSearching" class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner"></div>
    </div>
</template>

